export const styles = (theme) => ({
    tabContents: {
        paddingTop: 24,
    },
});
